"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
var Voucher = /** @class */ (function () {
    function Voucher(info) {
        this.price = info.price;
        this.createdAt = new Date().toISOString();
        this.code = Math.random().toString(36).substring(2, 6).toUpperCase();
        this.activated = false;
    }
    Voucher_1 = Voucher;
    Voucher.fromJson = function (json) {
        var voucher = new Voucher_1({ price: json.price });
        voucher.createdAt = json.createdAt;
        voucher.code = json.code;
        voucher.activated = json.activated;
        return voucher;
    };
    var Voucher_1;
    Voucher = Voucher_1 = tslib_1.__decorate([
        utils_1.StaticImplements()
    ], Voucher);
    return Voucher;
}());
exports.Voucher = Voucher;
var VoucherIdentifiable = /** @class */ (function (_super) {
    tslib_1.__extends(VoucherIdentifiable, _super);
    function VoucherIdentifiable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VoucherIdentifiable;
}(Voucher));
exports.VoucherIdentifiable = VoucherIdentifiable;
//# sourceMappingURL=voucher.js.map